import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'app-server-maintenance-page',
  imports: [],
  templateUrl: './server-maintenance-page.component.html',
  styleUrl: './server-maintenance-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServerMaintenancePageComponent {}
